export const INVALID_MDN_CODE = "INVALID_MDN" as const;

const DEFAULT_INVALID_MDN_MESSAGE = "The provided mobile directory number (MDN) is not valid.";

const eligibilityResponseCodes = [INVALID_MDN_CODE] as const;
export type EligibilityErrorResponseCode = (typeof eligibilityResponseCodes)[number];

// Parsed from an untrusted 400 response body — fields are optional because a
// malformed or unexpected error shape may omit them. Narrow before relying on them.
export interface EligibilityErrorResponse {
    code?: EligibilityErrorResponseCode;
    message?: string;
}

/**
 * Thrown when the eligibility API rejects the request because the customer's MDN
 * is invalid (HTTP 400 with body `{ code: "INVALID_MDN", ... }`). Mirrors the
 * backend's `InvalidMdnError` so the UI can offer inline MDN correction instead
 * of the generic "try refreshing" error view.
 */
export class InvalidMdnError extends Error {
    readonly code = INVALID_MDN_CODE;
    readonly statusCode = 400;

    constructor(message: string = DEFAULT_INVALID_MDN_MESSAGE, options?: ErrorOptions) {
        super(message, options);
        this.name = "InvalidMdnError";
        // Keep `instanceof` reliable across module/transpilation boundaries.
        Object.setPrototypeOf(this, InvalidMdnError.prototype);
    }
}

export function isInvalidMdnError(error: unknown): error is InvalidMdnError {
    return error instanceof InvalidMdnError;
}
